import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Core/Sidebar';
import Navbar from '../Core/Navbar';
import { ShoppingCart, Wallet, DollarSign, Key, ArrowRight, Package } from 'lucide-react';
import '../../Dashboard Style/AddBond.css';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { addBondKeysApi, getUserWalletBalanceApi } from '../../Services/Operations/ProductAPI';

const AddBond = () => {
  const navigate = useNavigate();
  const [quantity, setQuantity] = useState(1);
  const [availableAmount, setAvailableAmount] = useState(0);
  const [loadingBalance, setLoadingBalance] = useState(true);
  const [purchasing, setPurchasing] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const authToken = useSelector((state) => state.user?.token);
  const userData = useSelector((state) => state.user?.userData);

  const BOND_KEY_PRICE = 5; // Fixed price per bond key
  const MIN_QUANTITY = 1;
  const MAX_QUANTITY = 1000;

      const [isMobile, setIsMobile] = useState(false);
  
    // Check screen size on mount and resize
    useEffect(() => {
      const checkMobile = () => {
        const mobile = window.innerWidth < 992;
        setIsMobile(mobile);
  
        // Auto-close sidebar on mobile by default
        if (mobile) {
          setSidebarOpen(true);
        } else {
          setSidebarOpen(true);
        }
      };
  
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }, []);
  
  
  
    const closeSidebar = () => {
      if (isMobile) {
        setSidebarOpen(false);
      }
    };


  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Initialize sidebar functionality
  useEffect(() => {
    const sidebar = document.querySelector('.sidebar');
    const sidebarBody = document.querySelector('.sidebar-body');
    
    if (sidebar) {
      if (sidebarOpen) {
        sidebar.classList.remove('close');
      } else {
        sidebar.classList.add('close');
      }
    }
    
    if (sidebarBody) {
      sidebarBody.style.height = 'calc(100vh - 70px)';
      sidebarBody.style.overflowY = 'auto';
    }

    return () => {};
  }, [sidebarOpen]);

    useEffect(() => {
      // Add custom scrollbar styles for sidebar
      const style = document.createElement('style');
      style.innerHTML = `
        /* Custom scrollbar for sidebar */
        .sidebar-body {
          height: calc(100vh - 70px);
          overflow-y: auto;
        }
        
        .sidebar-body::-webkit-scrollbar {
          width: 6px;
        }
        
        .sidebar-body::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
        }
        
        .sidebar-body::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 10px;
        }
        
        .sidebar-body::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.3);
        }
      `;
      document.head.appendChild(style);
  
      // Fetch wallet balance on component mount
      fetchWalletBalance();
  
      return () => {
        document.head.removeChild(style);
      };
    }, []);

  useEffect(() => {
    // Add custom scrollbar styles for sidebar
    const style = document.createElement('style');
    style.innerHTML = `
      /* Custom scrollbar for sidebar */
      .sidebar-body {
        height: calc(100vh - 70px);
        overflow-y: auto;
      }
      
      .sidebar-body::-webkit-scrollbar {
        width: 6px;
      }
      
      .sidebar-body::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
      }
    `;
    document.head.appendChild(style);

    // Fetch wallet balance on component mount
    fetchWalletBalance();

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  
    useEffect(() => {
      const style = document.createElement('style');
      style.innerHTML = `
        .sidebar-body {
          height: calc(100vh - 70px);
          overflow-y: auto;
        }
        
        .sidebar-body::-webkit-scrollbar {
          width: 6px;
        }
        
        .sidebar-body::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
        }
        
        .sidebar-body::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 10px;
        }
        
        .sidebar-body::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.3);
        }
        
        .sidebar .nav-dropdown {
          list-style: none;
          padding-left: 0;
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
        }
        
        .sidebar .nav-dropdown.show {
          max-height: 500px;
        }
        
        .sidebar .nav-dropdown-item {
          padding-left: 2.5rem;
        }
        
        .nav-item.has-dropdown .nav-link {
          position: relative;
          padding-right: 2.5rem;
        }
        
        .nav-item.has-dropdown .dropdown-icon {
          position: absolute;
          right: 1rem;
          top: 50%;
          transform: translateY(-50%);
          transition: transform 0.3s ease;
        }
        
        .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
          transform: translateY(-50%) rotate(180deg);
        }
        
        .nav-item.has-dropdown .nav-dropdown {
          background: rgba(255, 255, 255, 0.05);
          border-left: 3px solid var(--primary-color, #0d6efd);
          margin-left: 1rem;
          border-radius: 0 0 8px 8px;
        }
        
        .nav-item.has-dropdown .nav-dropdown-item .nav-link {
          padding: 0.75rem 1rem 0.75rem 2rem;
          color: rgba(255, 255, 255, 0.8);
        }
        
        .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
          background: rgba(255, 255, 255, 0.1);
          color: white;
        }
        
        .nav-item.has-dropdown .link-title.nav-item.nav-category {
          font-weight: 600;
          font-size: 0.875rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .sidebar {
          transition: all 0.3s ease;
        }
      `;
      document.head.appendChild(style);
  
      return () => {
        document.head.removeChild(style);
      };
    }, []);

  const fetchWalletBalance = async () => {
    try {
      setLoadingBalance(true);
      
      // Get balance from user data or API
      if (userData?.wallets?.main_wallet) {
        setAvailableAmount(parseFloat(userData.wallets.main_wallet));
      } else {
        const result = await getUserWalletBalanceApi(authToken);
        if (result.status) {
          setAvailableAmount(parseFloat(result.data.main_wallet || result.data.balance || 0));
        } else {
          toast.error(result.message || 'Failed to load wallet balance');
        }
      }
    } catch (error) {
      console.error('Error fetching wallet balance:', error);
      toast.error('Failed to load wallet balance');
    } finally {
      setLoadingBalance(false);
    }
  };

  const calculateTotalAmount = () => {
    return quantity * BOND_KEY_PRICE;
  };

  const handleQuantityChange = (value) => {
    const numValue = parseInt(value, 10);
    if (isNaN(numValue)) return;
    
    if (numValue < MIN_QUANTITY) {
      setQuantity(MIN_QUANTITY);
    } else if (numValue > MAX_QUANTITY) {
      setQuantity(MAX_QUANTITY);
    } else {
      setQuantity(numValue);
    }
  };

  const incrementQuantity = () => {
    if (quantity < MAX_QUANTITY) {
      setQuantity(prev => prev + 1);
    }
  };

  const decrementQuantity = () => {
    if (quantity > MIN_QUANTITY) {
      setQuantity(prev => prev - 1);
    }
  };

  const handlePurchaseBond = async () => {
    const totalAmount = calculateTotalAmount();
    
    if (totalAmount > availableAmount) {
      toast.error('Insufficient funds in your wallet');
      return;
    }

    // Show confirmation dialog
    // const confirmed = window.confirm(
    //   `Are you sure you want to purchase ${quantity} Bond Key(s)?\n\n` +
    //   `Bond Key Price: $${BOND_KEY_PRICE.toFixed(2)} each\n` +
    //   `Quantity: ${quantity}\n` +
    //   `Total Amount: $${totalAmount.toFixed(2)}\n\n` +
    //   `Available Balance: $${availableAmount.toFixed(2)}\n\n` +
    //   `This action cannot be undone.`
    // );

    // if (!confirmed) return;

    try {
      setPurchasing(true);
      
      // Prepare form data for the API call
      const formData = new FormData();
      formData.append('quantity', quantity);
      // In the handlePurchaseBond function, replace the fetch call with:
const result = await addBondKeysApi(authToken, quantity);

      if (result.status) {
        toast.success(result.message || 'Bond Keys purchased successfully!');
        
        // fetchWalletBalance();
        
        // Reset form
        setQuantity(1);
        
        // Navigate to dashboard after delay
        setTimeout(() => {
          navigate('/dashboard');
        }, 2000);
      } else {
        toast.error(result.message || 'Purchase failed');
      }
    } catch (error) {
      console.error('Error purchasing bond keys:', error);
      toast.error('Failed to purchase bond keys. Please try again.');
    } finally {
      setPurchasing(false);
    }
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  return (
    <div className="main-wrapper dark-theme">
      {/* Sidebar */}
      <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
        <div className="sidebar-header">
          <a href="#" className="sidebar-brand">
            <i className="me-2" data-lucide="atom"></i>
            Willow <span>Quantum</span>
          </a>
          <div className="sidebar-toggler" onClick={toggleSidebar}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
         <Sidebar
                           isOpen={!sidebarOpen}
                           onClose={closeSidebar}
                         />
               
                         {/* Mobile backdrop */}
                         {isMobile && sidebarOpen && (
                           <div
                             className="sidebar-backdrop"
                             onClick={closeSidebar}
                           />
                         )}
      </nav>

      <div className="page-wrapper">
        {/* Navbar */}
        <Navbar toggleSidebar={toggleSidebar}  isSidebarOpen={sidebarOpen}
                   isMobile={isMobile}/>
       

        {/* Main Content */}
        <div className="page-content">
          <div className="wallet-transfer-container-dark">
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="" style={{width:"100%"}}>
                  {/* Main Card */}
                  <div className="dark-transfer-card">
                    <div className="dark-balance-section">
                      <div className="balance-card-dark">
                        <div className="balance-content">
                          <div className="balance-label-dark">My Wallet Balance</div>
                          <div className="balance-amount-dark">
                            {loadingBalance ? (
                              <span className="spinner-border spinner-border-sm me-2"></span>
                            ) : (
                              `$${formatAmount(availableAmount)}`
                            )}
                          </div>
                          <div className="balance-subtitle-dark">Quantum Main Vault • Ready to Purchase</div>
                        </div>
                        <div className="wallet-icon-dark">
                          <Wallet size={40} />
                        </div>
                      </div>
                    </div>

                    {/* Bond Key Information */}
                    <div className="bond-key-info-section">
                      <div className="bond-key-card">
                        <div className="bond-key-header">
                          <Key size={32} className="bond-key-icon" />
                          <h3 className="bond-key-title">Purchase Bond Keys</h3>
                        </div>
                        <div className="bond-key-content">
                          <div className="bond-price-display">
                            <div className="bond-price-label">Bond Key Price</div>
                            <div className="bond-price-amount">${BOND_KEY_PRICE.toFixed(2)}</div>
                            <div className="bond-price-note">Fixed price per bond key</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Quantity Input Section */}
                    <div className="quantity-section-dark">
                      <div className="form-group-dark">
                        <label className="form-label-dark">
                          <Package size={18} className="me-2" />
                          Select Quantity
                        </label>
                        
                        <div className="quantity-input-container">
                          <div className="quantity-input-group">
                            <button
                              type="button"
                              className="quantity-btn minus"
                              onClick={decrementQuantity}
                              disabled={quantity <= MIN_QUANTITY || purchasing}
                            >
                              −
                            </button>
                            
                            <div className="quantity-display">
                              <input
                                type="number"
                                className="quantity-input"
                                value={quantity}
                                onChange={(e) => handleQuantityChange(e.target.value)}
                                min={MIN_QUANTITY}
                                max={MAX_QUANTITY}
                                disabled={purchasing}
                              />
                              <span className="quantity-label">Bond Keys</span>
                            </div>
                            
                            <button
                              type="button"
                              className="quantity-btn plus"
                              onClick={incrementQuantity}
                              disabled={quantity >= MAX_QUANTITY || purchasing}
                            >
                              +
                            </button>
                          </div>
                          
                          <div className="quantity-limits">
                            <span>Min: {MIN_QUANTITY}</span>
                            <span>Max: {MAX_QUANTITY}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Order Summary */}
                    <div className="order-summary-section">
                      <div className="order-summary-card">
                        <h4 className="order-summary-title">Order Summary</h4>
                        
                        <div className="order-summary-items">
                          <div className="order-summary-item">
                            <span className="item-label">Bond Key Price:</span>
                            <span className="item-value">${BOND_KEY_PRICE.toFixed(2)}</span>
                          </div>
                          
                          <div className="order-summary-item">
                            <span className="item-label">Quantity:</span>
                            <span className="item-value">{quantity}</span>
                          </div>
                          
                          <div className="order-summary-divider"></div>
                          
                          <div className="order-summary-item total">
                            <span className="item-label">Total Amount:</span>
                            <span className="item-value total-amount">
                              ${formatAmount(calculateTotalAmount())}
                            </span>
                          </div>
                          
                          <div className="order-summary-item">
                            <span className="item-label">Available Balance:</span>
                            <span className={`item-value ${calculateTotalAmount() > availableAmount ? 'insufficient' : 'sufficient'}`}>
                              ${formatAmount(availableAmount)}
                            </span>
                          </div>
                          
                          {calculateTotalAmount() > availableAmount && (
                            <div className="insufficient-funds-alert">
                              <div className="alert alert-danger mb-0">
                                <strong>Insufficient Funds!</strong> You need ${formatAmount(calculateTotalAmount() - availableAmount)} more to complete this purchase.
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="submit-section">
                      <button 
                        type="button" 
                        className="submit-btn-dark purchase-btn"
                        onClick={handlePurchaseBond}
                        disabled={purchasing || loadingBalance || calculateTotalAmount() > availableAmount}
                      >
                        {purchasing ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Processing Purchase...
                          </>
                        ) : (
                          <>
                            <ShoppingCart size={22} className="me-3" />
                            Purchase {quantity} Bond Key{quantity !== 1 ? 's' : ''} for ${formatAmount(calculateTotalAmount())}
                            <ArrowRight size={18} className="ms-2" />
                          </>
                        )}
                      </button>
                      
                      <p className="text-muted text-center mt-3 small">
                        Bond keys are non-refundable and will be added to your account immediately upon purchase.
                      </p>
                    </div>

                    {/* Features */}
                    <div className="features-section mt-4">
                      <div className="row">
                        <div className="col-md-4 mb-3">
                          <div className="feature-item">
                            <div className="feature-icon secure-feature">
                              <Key size={20} />
                            </div>
                            <div className="feature-content">
                              <div className="feature-title">Secure Investment</div>
                              <div className="feature-desc">Backed by blockchain</div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <div className="feature-item">
                            <div className="feature-icon fast-feature">
                              <Package size={20} />
                            </div>
                            <div className="feature-content">
                              <div className="feature-title">Instant Delivery</div>
                              <div className="feature-desc">Keys delivered immediately</div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <div className="feature-item">
                            <div className="feature-icon low-feature">
                              <DollarSign size={20} />
                            </div>
                            <div className="feature-content">
                              <div className="feature-title">Fixed Price</div>
                              <div className="feature-desc">Stable $5 per key</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer-dark">
          <div className="container">
            <p className="text-center mb-0">
              Copyright © 2025 Willow Quantum. All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default AddBond;